import { render, staticRenderFns } from "./BacklogReport.vue?vue&type=template&id=2d16dd8d"
import script from "./BacklogReport.vue?vue&type=script&lang=js"
export * from "./BacklogReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports